import { render, staticRenderFns } from "./StatusForm.vue?vue&type=template&id=0f9573c1&scoped=true"
import script from "./StatusForm.vue?vue&type=script&lang=js"
export * from "./StatusForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9573c1",
  null
  
)

export default component.exports